class QuickAddPopover extends HTMLElement {
  constructor() {
    super();

    const trigger = this.querySelector('[js-trigger]');
    const popover = this.querySelector('[js-popover]');
    const closeBtn = this.querySelector('[js-close]');
    const variants = this.querySelectorAll('[js-variant]');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        popover.classList.toggle('hidden');
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        popover.classList.add('hidden');
      });
    }
    if (variants.length) {
      variants.forEach((variant) => {
        variant.addEventListener('click', (e) => {
          e.stopPropagation();
          if (!variant.dataset.variantId) return;
          popover.classList.add('hidden');
          if (trigger) {
            trigger.classList.add('loading');
            trigger.disabled = true;
          }
          Cart.addItemToCart(variant.dataset.variantId);
        });
      });
    }
  }

  handleVariantClick(evt) {
    evt.stopPropagation();
  }
}

if (!customElements.get('quick-add-popover')) {
  customElements.define('quick-add-popover', QuickAddPopover);
}
